// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Globe, Facebook, Instagram, Youtube, Linkedin, Twitter } from 'lucide-react';
// import axios from 'axios';

// // Custom TikTok icon component (since it's not in lucide-react by default)
// const TikTokIcon = ({ size = 18, className = "" }) => (
//   <svg 
//     xmlns="http://www.w3.org/2000/svg" 
//     width={size} 
//     height={size} 
//     viewBox="0 0 24 24" 
//     fill="none" 
//     stroke="currentColor" 
//     strokeWidth="2" 
//     strokeLinecap="round" 
//     strokeLinejoin="round" 
//     className={className}
//   >
//     <path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path>
//     <path d="M15 8h.01"></path>
//     <path d="M12 2v10c0 .6-.4 1-1 1H2"></path>
//     <path d="M8 16v-3"></path>
//     <path d="M16 8a5 5 0 0 0 5 5v-3a6 6 0 0 1-5-5"></path>
//   </svg>
// );

// const Footer = () => {
//   const navigate = useNavigate();
  
//   // State for contact information
//   const [contactInfo, setContactInfo] = useState({
//     address: '1646 N California Blvd Walnut Creek, CA 94596',
//     phone: '+1 720-737-2513',
//     email: 'BK@BrianKarsh.com'
//   });
  
//   // State for latest blog posts
//   const [latestBlogs, setLatestBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
  

//   // Fetch contact information from API
//   useEffect(() => {
//     const fetchContactInfo = async () => {
//       try {
//         const response = await fetch("/api/get_contact_section");
        
//         if (!response.ok) {
//           console.log(`Error fetching contact info: ${response.status}`);
//           return; // Use default values
//         }
        
//         const data = await response.json();
        
//         // Update contact info with fetched data
//         if (data) {
//           setContactInfo({
//             address: data.address || contactInfo.address,
//             phone: data.phone || contactInfo.phone,
//             email: data.email || contactInfo.email
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching contact information:", error);
//       }
//     };

//     const fetchLatestBlogs = async () => {
//       try {
//         const response = await axios.get('/api/blogs');
        
//         if (response.data && response.data.posts) {
//           // Get the latest 3 blog posts
//           const latestPosts = response.data.posts.slice(0, 3);
//           setLatestBlogs(latestPosts);
//         }
//       } catch (error) {
//         console.error("Error fetching latest blogs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     // Execute both fetch operations
//     fetchContactInfo();
//     fetchLatestBlogs();
//   }, []);

//   // Truncate title if it's too long
//   const truncateTitle = (title, maxLength = 28) => {
//     if (title.length <= maxLength) return title;
//     return title.substring(0, maxLength) + '...';
//   };

//   return (
//     <footer className="bg-black text-white mt-16">
//       {/* Container */}
//       <div className="max-w-6xl mx-auto px-6 py-12">
//         {/* 
//           Top Section: Responsive grid with:
//           - 1 column on extra-small devices
//           - 2 columns on small (sm) devices
//           - 4 columns on medium (md) and up
//         */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
//           {/* 1) Communities */}
//           <div>
//             <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
//               Communities
//             </h3>
//             <ul className="space-y-2 text-sm text-gray-300">
//               <li>
//                 <Link to="/community/1" className="hover:text-white">
//                   MacDonald Highlands
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/community/2" className="hover:text-white">
//                   Anthem Country Club
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/community/3" className="hover:text-white">
//                   Lake Las Vegas
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/community/4" className="hover:text-white">
//                   Madeira Canyon
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* 2) Helpful Links */}
//           <div>
//             <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
//               Helpful Links
//             </h3>
//             <ul className="space-y-2 text-sm text-gray-300">
//               <li>
//                 <Link to="/about" className="hover:text-white">
//                   About
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/buy" className="hover:text-white">
//                   Buy
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/sell" className="hover:text-white">
//                   Sell
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/contact" className="hover:text-white">
//                   Contact
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* 3) Blog - Now dynamically populated with latest blog posts */}
//           <div>
//             <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
//                Blog
//             </h3>
//             <ul className="space-y-2 text-sm text-gray-300">
//               {loading ? (
//                 <li>Loading latest posts...</li>
//               ) : latestBlogs.length > 0 ? (
//                 <>
//                   {latestBlogs.map(blog => (
//                     <li key={blog.id}>
//                       <Link 
//                         to={`/blogs/${blog.id}`} 
//                         className="hover:text-white transition-colors duration-200"
//                         onClick={() => window.scrollTo(0, 0)}
//                       >
//                         {truncateTitle(blog.title)}
//                       </Link>
//                     </li>
//                   ))}
//                   <li className="mt-4">
//                     <Link 
//                       to="/blogs" 
//                       className="text-blue-400 hover:text-blue-300 transition-colors duration-200 font-medium"
//                       onClick={() => window.scrollTo(0, 0)}
//                     >
//                       View All Posts →
//                     </Link>
//                   </li>
//                 </>
//               ) : (
//                 <>
//                   <li>No blog posts available</li>
//                   <li>
//                     <Link to="/blogs" className="hover:text-white">
//                       All Posts
//                     </Link>
//                   </li>
//                 </>
//               )}
//             </ul>
//           </div>

//           {/* 4) Contacts - Dynamically populated */}
//           <div>
//             <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
//               Contacts
//             </h3>
//             <ul className="space-y-2 text-sm text-gray-300">
//               <li>{contactInfo.address}</li>
//               <li>Mobile: {contactInfo.phone}</li>
//               <li>Email: {contactInfo.email}</li>
//             </ul>
//           </div>
//         </div>

//         {/* 
//           Bottom Section: 
//           - Stacked (flex-col) on mobile
//           - Side-by-side (flex-row) on md+ 
//         */}
//         <div className="mt-10 border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between">
//           {/* Left side: brand / copyright */}
//           <div className="text-gray-400 text-sm mb-4 md:mb-0 text-center md:text-left">
//             © 2025 Brian Karsh Compass Real Estate. DRE #01234562
//           </div>

//           {/* Right side: social icons / language switch / etc. */}
//           <div className="flex items-center space-x-5">
//             <a
//               href="https://BrianKarsh.com"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="Website"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Globe size={18} />
//             </a>
//             <a
//               href="https://www.facebook.com/briansells5280"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="Facebook"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Facebook size={18} />
//             </a>
//             <a
//               href="https://www.instagram.com/briankarsh/?hl=en"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="Instagram"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Instagram size={18} />
//             </a>
//             <a
//               href="https://www.tiktok.com/@therealkarsh"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="TikTok"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <TikTokIcon size={18} />
//             </a>
//             <a
//               href="https://www.twitter.com/brianksells5280"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="Twitter"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Twitter size={18} />
//             </a>
//             <a
//               href="https://www.youtube.com/@briankarsh3086"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="YouTube"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Youtube size={18} />
//             </a>
//             <a
//               href="https://www.linkedin.com/in/brian-karsh-5321b616"
//               className="text-gray-400 hover:text-white transition-colors"
//               aria-label="LinkedIn"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Linkedin size={18} />
//             </a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;




















import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Globe, Facebook, Instagram, Youtube, Linkedin, Twitter, MapPin, Phone, Mail } from 'lucide-react';
import axios from 'axios';

// Custom TikTok icon component (since it's not in lucide-react by default)
const TikTokIcon = ({ size = 18, className = "" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path>
    <path d="M15 8h.01"></path>
    <path d="M12 2v10c0 .6-.4 1-1 1H2"></path>
    <path d="M8 16v-3"></path>
    <path d="M16 8a5 5 0 0 0 5 5v-3a6 6 0 0 1-5-5"></path>
  </svg>
);

const Footer = () => {
  const navigate = useNavigate();
  
  // State for contact information
  const [contactInfo, setContactInfo] = useState({
    address: 'Loading...',
    phone: 'Loading...',
    email: 'Loading...'
  });
  
  // State for latest blog posts
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  // Fetch contact information from API
  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/get_contact_section`);
        
        if (!response.ok) {
          console.log(`Error fetching contact info: ${response.status}`);
          // Set fallback values if API fails
          setContactInfo({
            address: '1646 N California Blvd Walnut Creek, CA 94596',
            phone: '+1 720-737-2513',
            email: 'BK@BrianKarsh.com'
          });
          return;
        }
        
        const data = await response.json();
        
        // Update contact info with fetched data
        if (data) {
          setContactInfo({
            address: data.address || 'Address not available',
            phone: data.phone || 'Phone not available',
            email: data.email || 'Email not available'
          });
          console.log("Contact info loaded in footer:", data);
        }
      } catch (error) {
        console.error("Error fetching contact information:", error);
        // Set fallback values if API fails
        setContactInfo({
          address: '1646 N California Blvd Walnut Creek, CA 94596',
          phone: '+1 720-737-2513',
          email: 'BK@BrianKarsh.com'
        });
      }
    };

    const fetchLatestBlogs = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/blogs`);
        
        if (response.data && response.data.posts) {
          // Get the latest 3 blog posts
          const latestPosts = response.data.posts.slice(0, 3);
          setLatestBlogs(latestPosts);
        }
      } catch (error) {
        console.error("Error fetching latest blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    // Execute both fetch operations
    fetchContactInfo();
    fetchLatestBlogs();
  }, []);

  // Re-fetch contact info when localStorage changes (to sync with ContactSection updates)
  useEffect(() => {
    // Create a custom event listener for contact info changes
    const handleContactInfoChange = () => {
      const fetchUpdatedContactInfo = async () => {
        try {
          const response = await fetch(`${backendUrl}/api/get_contact_section`);
          
          if (!response.ok) {
            console.log(`Error refetching contact info: ${response.status}`);
            return;
          }
          
          const data = await response.json();
          
          if (data) {
            setContactInfo({
              address: data.address || contactInfo.address,
              phone: data.phone || contactInfo.phone,
              email: data.email || contactInfo.email
            });
            console.log("Contact info updated in footer:", data);
          }
        } catch (error) {
          console.error("Error refetching contact information:", error);
        }
      };

      fetchUpdatedContactInfo();
    };

    // Add event listener for contact info changes
    window.addEventListener('contactInfoUpdated', handleContactInfoChange);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('contactInfoUpdated', handleContactInfoChange);
    };
  }, [contactInfo]);

  // Truncate title if it's too long
  const truncateTitle = (title, maxLength = 28) => {
    if (title.length <= maxLength) return title;
    return title.substring(0, maxLength) + '...';
  };

  return (
    <footer className="bg-black text-white mt-16">
      {/* Container */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        {/* 
          Top Section: Responsive grid with:
          - 1 column on extra-small devices
          - 2 columns on small (sm) devices
          - 4 columns on medium (md) and up
        */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* 1) Communities */}
          <div>
            <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
              Communities
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/community/1" className="hover:text-white">
                  MacDonald Highlands
                </Link>
              </li>
              <li>
                <Link to="/community/2" className="hover:text-white">
                  Anthem Country Club
                </Link>
              </li>
              <li>
                <Link to="/community/3" className="hover:text-white">
                  Lake Las Vegas
                </Link>
              </li>
              <li>
                <Link to="/community/4" className="hover:text-white">
                  Madeira Canyon
                </Link>
              </li>
            </ul>
          </div>

          {/* 2) Helpful Links */}
          <div>
            <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
              Helpful Links
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/about" className="hover:text-white">
                  About
                </Link>
              </li>
              <li>
                <Link to="/buy" className="hover:text-white">
                  Buy
                </Link>
              </li>
              <li>
                <Link to="/sell" className="hover:text-white">
                  Sell
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* 3) Blog - Now dynamically populated with latest blog posts */}
          <div>
            <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
               Blog
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              {loading ? (
                <li>Loading latest posts...</li>
              ) : latestBlogs.length > 0 ? (
                <>
                  {latestBlogs.map(blog => (
                    <li key={blog.id}>
                      <Link 
                        to={`/blogs/${blog.id}`} 
                        className="hover:text-white transition-colors duration-200"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {truncateTitle(blog.title)}
                      </Link>
                    </li>
                  ))}
                  <li className="mt-4">
                    <Link 
                      to="/blogs" 
                      className="text-blue-400 hover:text-blue-300 transition-colors duration-200 font-medium"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      View All Posts →
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li>No blog posts available</li>
                  <li>
                    <Link to="/blogs" className="hover:text-white">
                      All Posts
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* 4) Contacts - Dynamically populated */}
          <div>
            <h3 className="font-semibold mb-4 uppercase tracking-wider text-gray-100">
              Contacts
            </h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-red-600 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <MapPin className="text-white" size={14} />
                </div>
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-red-600 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <Phone className="text-white" size={14} />
                </div>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 rounded-full bg-red-600 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
                    <rect width="20" height="16" x="2" y="4" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </div>
                <span>{contactInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>
        {/* 
          Bottom Section: 
          - Stacked (flex-col) on mobile
          - Side-by-side (flex-row) on md+ 
        */}
        <div className="mt-10 border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between">
          {/* Left side: brand / copyright */}
          <div className="text-gray-400 text-sm mb-4 md:mb-0 text-center md:text-left">
            © 2025 Brian Karsh Compass Real Estate. DRE #01234562
          </div>

          {/* Right side: social icons / language switch / etc. */}
          <div className="flex items-center space-x-5">
            <a
              href="https://BrianKarsh.com"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Website"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Globe size={18} />
            </a>
            <a
              href="https://www.facebook.com/briansells5280"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={18} />
            </a>
            <a
              href="https://www.instagram.com/briankarsh/?hl=en"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://www.tiktok.com/@therealkarsh"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="TikTok"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TikTokIcon size={18} />
            </a>
            <a
              href="https://www.twitter.com/brianksells5280"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Twitter"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter size={18} />
            </a>
            <a
              href="https://www.youtube.com/@briankarsh3086"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Youtube size={18} />
            </a>
            <a
              href="https://www.linkedin.com/in/brian-karsh-5321b616"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;